import { defineMessages } from 'react-intl'

const scope = `procurify.components.BudgetCategoryAttributesCard`

export default defineMessages({
  budgetAttributesCardHeader: {
    id: `${scope}.budgetAttributesCardHeader`,
    defaultMessage: 'Budget details',
  },
  secondaryOrgCategoryLabel: {
    id: `${scope}.secondaryOrgCategoryLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  accountCodesLabel: {
    id: `${scope}.accountCodesLabel`,
    defaultMessage: 'Account code',
  },
  viewersLabel: {
    id: `${scope}.viewers`,
    defaultMessage: 'Viewers',
  },
  inactiveCustomFieldLabel: {
    id: `${scope}.inactiveCustomFieldLabel`,
    defaultMessage: '{name} (inactive)',
  },
  checkboxCheckedValue: {
    id: `${scope}.checkboxCheckedValue`,
    defaultMessage: 'Yes',
  },
  checkboxUncheckedValue: {
    id: `${scope}.checkboxUncheckedValue`,
    defaultMessage: 'No',
  },
})
